export default function youtubeDeepLink(id: any) {
  return `https://m.youtube.com/watch?v=${id}`;
}
